import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import CommonOrderComponent from "~/components/parking/Checkout/CommonOrderComponent"
import { PayNycFeeShownTracker } from "~/components/tracking/FeeShownTracker"
import { PAYMENT_PROVIDERS } from "~/utilities/constants"


@inject(all => ({
  totalSelectedPayableAmount: all.store.parkingFlow.results.totalSelectedPayableAmount,
  feeForSelectedPayable: all.store.parkingFlow.results.feeForSelectedPayable,
  totalServiceFee: all.store.parkingFlow.results.totalServiceFee,
  paySubtotal: all.store.parkingFlow.results.paySubtotal,
  userCredits: all.store.auth.user.credits,
  paymentProcessor: all.store.payment.paymentProcessor,
  ticketCount: all.store.parkingFlow.results.paySelected.length,
  isPayNYCFlow: all.store.ui.isPayNYCFlow,
}))

@observer
class OrderCard extends Component {

  render() {
    const {
      userCredits,
      totalSelectedPayableAmount,
      totalServiceFee,
      feeForSelectedPayable,
      paySubtotal,
      paymentProcessor,
      ticketCount,
      isPayNYCFlow,
    } = this.props
    let finalPaySubTotal = paySubtotal
    let finalUserCredits = userCredits
    if (paymentProcessor === PAYMENT_PROVIDERS.evervault && userCredits > 0) {
      finalPaySubTotal -=  Math.min(totalServiceFee, userCredits) - userCredits
      finalUserCredits = Math.min(totalServiceFee, userCredits)
    }
    const isEvervault = paymentProcessor === PAYMENT_PROVIDERS.evervault
    return (
      <>
        {isPayNYCFlow && (
          <PayNycFeeShownTracker
            serviceFee={totalServiceFee}
            cardFee={feeForSelectedPayable}
            subtotal={totalSelectedPayableAmount}
            total={finalPaySubTotal}
            feeType={isEvervault ? "service_fee_and_city_card_fee" : "service_fee_and_processing_fee"}
            ticketCount={ticketCount}
            paymentProcessor={paymentProcessor}
          />
        )}
        {isEvervault ? (
          <CommonOrderComponent
            payableAmount={totalSelectedPayableAmount}
            serviceFee={feeForSelectedPayable}
            processingFee={totalServiceFee}
            userCredits={finalUserCredits}
            paySubTotal={finalPaySubTotal}
            paymentProcessor={paymentProcessor}
          />
        ) : (
          <CommonOrderComponent
            payableAmount={totalSelectedPayableAmount}
            serviceFee={totalServiceFee}
            processingFee={feeForSelectedPayable}
            userCredits={userCredits}
            paySubTotal={finalPaySubTotal}
            paymentProcessor={paymentProcessor}
          />
        )}
      </>
    )
  }
}

export default OrderCard
